import api, { clearToken, getCompanyId, getToken, setCompanyId, setToken } from "@/lib/api";

const ADMIN_TOKEN = "pnl_admin_token";
const ADMIN_COMPANY = "pnl_admin_company";

export const isImpersonating = () => !!localStorage.getItem(ADMIN_TOKEN);

/** Switch this browser to the target user's session; the super admin's own token is kept to return. */
export const startImpersonation = async (uid) => {
  const { data } = await api.post(`/admin/impersonate/${uid}`);
  localStorage.setItem(ADMIN_TOKEN, getToken());
  localStorage.setItem(ADMIN_COMPANY, getCompanyId() || "");
  setToken(data.access_token);
  setCompanyId(null);
  sessionStorage.setItem("splash_shown", "1");
  window.location.assign(data.user.is_task_user ? "/work" : "/");
};

/** Restore the super admin's own session (also used when the impersonation token expires). */
export const restoreAdmin = (path = "/admin/users") => {
  const t = localStorage.getItem(ADMIN_TOKEN);
  const c = localStorage.getItem(ADMIN_COMPANY);
  localStorage.removeItem(ADMIN_TOKEN);
  localStorage.removeItem(ADMIN_COMPANY);
  if (!t) return false;
  setToken(t);
  setCompanyId(c || null);
  window.location.assign(path);
  return true;
};

export const endImpersonation = async () => {
  try { await api.post("/admin/impersonate/end"); } catch (_) { /* expired: still return */ }
  if (!restoreAdmin()) { clearToken(); window.location.assign("/login"); }
};

export const forgetAdminReturn = () => { localStorage.removeItem(ADMIN_TOKEN); localStorage.removeItem(ADMIN_COMPANY); };
